// Tokens de contraste da sidebar. O `bg_navbar` é configurável por escritório
// (main.js -> updateColors), então a sidebar não pode assumir fundo escuro: um
// escritório com navbar branca deixaria texto branco sobre branco.
//
// A regra de contraste é a mesma da nav antiga (button-navbar/suspended-nav-bar):
// `textOnColor` decide entre claro e escuro pela luminância do fundo. Aqui ela é
// convertida em CSS custom properties aplicadas na casca, para os descendentes
// escreverem `rgba(var(--nav-fg-rgb), α)` em vez de branco fixo — em fundo escuro
// o resultado é idêntico ao anterior.
import { textOnColor, hexToRgb } from '@modules/global/utils/Color'

// Fundo usado quando o escritório não personaliza (mesmo default do main.js).
export const DEFAULT_NAV_BG = '#030309'
// Valor que `textOnColor` devolve quando o fundo é claro.
const FG_ON_LIGHT = '#131416'
// Painel flutuante do seletor de cliente: um degrau acima do fundo da sidebar.
const PANEL_BG = { DARK: '#15151a', LIGHT: '#ffffff' }
// Âmbar do selo "Lead". O tom escuro é ilegível sobre branco, daí o par.
const LEAD_FG = { DARK: '#ffd166', LIGHT: '#8a5a00' }

// Cor de texto/ícone legível sobre o fundo da sidebar.
export const navForeground = (bg) => textOnColor(bg || DEFAULT_NAV_BG)

export const isLightNavBg = (bg) => navForeground(bg) === FG_ON_LIGHT

// Objeto de estilo (Vue) com as custom properties da superfície da sidebar.
export const navSurfaceVars = (bg) => {
  const foreground = navForeground(bg)
  const light = foreground === FG_ON_LIGHT
  return {
    '--nav-fg': foreground,
    // Componentes de cor separados para compor alfa no CSS: rgba(var(--nav-fg-rgb), 0.08).
    '--nav-fg-rgb': hexToRgb(foreground).join(', '),
    '--nav-panel-bg': light ? PANEL_BG.LIGHT : PANEL_BG.DARK,
    '--nav-lead-fg': light ? LEAD_FG.LIGHT : LEAD_FG.DARK,
  }
}
